import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Skeleton from '@mui/material/Skeleton';
import { VARIANTS } from '../constants/variants';

const SKELETON_ITEMS = [{ key: 1 }, { key: 2 }];

const SkeletonContent = () => {
  return (
    <AnimatePresence>
      {SKELETON_ITEMS.map(item => {
        return (
          <motion.div
            key={item.key}
            layout
            initial={{ scale: 0.4, opacity: 0, y: 50 }}
            exit={{
              scale: 0,
              opacity: 0,
              transition: { duration: 0.2 }
            }}
            animate={{ scale: 1, opacity: 1, y: 0 }}>
            <motion.article
              key={item.key}
              className='notification-item'
              variants={VARIANTS.ITEM_VARIANT}>
              <div className='notification-icon'>
                <Skeleton variant='circular' height={40} />
              </div>
              <div className='notification-item-content'>
                <Skeleton variant='rectangular' width={300} />
                <Skeleton variant='rectangular' width={150} />
              </div>
            </motion.article>
          </motion.div>
        );
      })}
    </AnimatePresence>
  );
};

export default SkeletonContent;
